import React from 'react';
import { useProgress } from '../hooks/useProgress';
import { usePreferences } from '../state/usePreferences';
import Deadline from './Deadline';
const Tick = () => React.createElement("svg", {
  width: "11",
  height: "11",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: "3.2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": "true"
}, React.createElement("path", {
  d: "M20 6L9 17l-5-5"
}));
const ProgressBand = ({
  isPhone
}) => {
  const {
    goTo,
    bookingName
  } = usePreferences();
  const {
    steps,
    markerLeft,
    positionLabel
  } = useProgress();
  return React.createElement("div", {
    className: "cp-progress"
  }, React.createElement("div", {
    className: "cp-progress-eyebrow"
  }, React.createElement("span", null, "Creative preferences"), bookingName && React.createElement("span", {
    className: "cp-eyebrow-name"
  }, bookingName), React.createElement("span", null, positionLabel, React.createElement(Deadline, null))), React.createElement("div", {
    className: "cp-progress-row",
    style: {
      gridTemplateColumns: `repeat(${steps.length}, minmax(0, 1fr))`
    }
  }, React.createElement("span", {
    className: "cp-progress-marker",
    style: {
      left: markerLeft(isPhone)
    }
  }), steps.map(step => {
    const state = step.done ? 'is-done' : step.current ? 'is-current' : 'is-ahead';
    return React.createElement("button", {
      key: step.key,
      type: "button",
      className: `cp-step${step.current ? ' is-current' : ''}${step.dim ? ' is-dim' : ''}`,
      onClick: () => goTo(step.key)
    }, React.createElement("span", {
      className: "cp-step-head"
    }, React.createElement("span", {
      className: `cp-dot ${state}`
    }, step.done ? React.createElement(Tick, null) : React.createElement("span", {
      className: "cp-dot-num"
    }, step.index + 1)), React.createElement("span", {
      className: "cp-step-label"
    }, step.label)), React.createElement("span", {
      className: "cp-step-track"
    }, step.segments.map((seg, i) => React.createElement("span", {
      className: "cp-track",
      key: i
    },
    // Walking past a section is not the same as answering it. This layer
    // only marks one the client has been refused on, so the unanswered
    // part of a section they merely left stays empty track rather than
    // reading as progress the bar then has to argue with.
    React.createElement("span", {
      className: "cp-track-past",
      style: {
        width: seg.past ? '100%' : '0%'
      }
    }), React.createElement("span", {
      className: "cp-track-fill",
      style: {
        width: `${Math.round(seg.pct * 100)}%`
      }
    })))));
  })));
};
export default ProgressBand;
